import DropdownInput from './DropdownInput';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { options } from '../../data/socionics/data/types';
import { Card } from 'react-bootstrap';

function InputForm(props) {
    return (
        <div className='pt-5'>
            <Card className='bg-dark h-75 pt-5 rounded-5 w-75 m-auto'>
                <div className='my-auto'>
                    <Row lg={4} xs={1} md={3} className='justify-content-center px-5'>
                        <Col className='pb-4'>
                            <div className='text-light text-center h1'>
                                <b>Your Type</b>
                            </div>
                            <br></br>
                            <DropdownInput
                                name='Personality'
                                label='Personality'
                                options={options}
                                onChange={props.handleChange} />
                        </Col>

                        <Col>
                            <div className='text-light text-center h1'>
                                <b>Their Type</b>
                            </div>
                            <br></br>
                            <DropdownInput
                                name='Personality2'
                                label='Personality2'
                                options={options}
                                onChange={props.handleChange1} />
                        </Col>
                    </Row>
                    <br></br>
                </div>
            </Card>
        </div>
    )
}
export default InputForm